import { usePage } from "@inertiajs/react";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import Container from "hardcover-ui/components/Container";
import ProfileWrapper from "components/profile/ProfileWrapper";
import Pagination from "components/shared/Pagination";
import { UserListsPageProps } from "./index.props";
import useCurrentUserId from "hooks/user/useCurrentUserId";
import ListNav from "components/profile/ListNav";
import Callout from "hardcover-ui/components/Callout";
import Text from "hardcover-ui/components/Text";
import NewListButton from "components/profile/NewListButton";
import BookListGroup from "components/BookGroup/groups/BookListGroup";

function UserGoalsPage() {
  const { user, lists } = usePage<UserListsPageProps>().props;
  const currentUserId = useCurrentUserId();

  return (
    <ProfileWrapper user={user}>
      <Container size="lg" className="pt-4 md:px-2">
        <ListNav user={user} />

        <div className="mt-4">
          {lists.length === 0 ? (
            <Callout variant="secondary">
              <Text variant="secondary">
                {user.name !== "Name" ? `${user.name}` : `@${user.username}`}{" "}
                has no lists
              </Text>
            </Callout>
          ) : (
            <>
              {currentUserId === user.id ? (
                <div className="flex flex-col sm:flex-row justify-between sm:space-x-4 space-y-2 items-start lg:items-center">
                  <Callout variant="secondary" className="grow mt-2">
                    <Text variant="secondary" as="p">
                      Tip: You can create new lists from here, or from the Book
                      Button.
                    </Text>
                  </Callout>

                  <div className="flex-none">
                    <NewListButton />
                  </div>
                </div>
              ) : (
                false
              )}
              <div className="mt-4 divide-y-2 divide-gray-100 dark:divide-gray-700 ">
                {lists.map((list) => (
                  <div key={`book-list-${list.id}`} className="py-4 lg:py-8">
                    <BookListGroup list={list} size="md" />
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

        <Pagination />
      </Container>
    </ProfileWrapper>
  );
}

UserGoalsPage.layout = DefaultLayoutWrapper;
export default UserGoalsPage;
